import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiHttpResponse } from '@kinomap-dev/ng-ui-lib';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { Settings } from '../models/settings.model';

@Injectable({
  providedIn: 'root',
})
export class ConfigApi {
  constructor(private readonly http: HttpClient) {}

  getMySettings(): Observable<Settings> {
    const url: string = environment.api.dashboard.mySettings;
    return this.http.get<ApiHttpResponse<Settings>>(url).pipe(
      map((settings: any) => {
        const defaultDateFormat: string = settings.data['default_date_format'];
        const dateFormat:string = defaultDateFormat.split(' ')[0].replace('m', 'MM');
        const hourFormat: string = defaultDateFormat.split(' ')[2]
          ? 'hh:mm a'
          : 'HH:mm';
        settings.data['default_date_format'] = `${dateFormat} ${hourFormat}`;
        return settings.data;
      })
    );
  }
}
